module.exports = __webpack_public_path__ + "static/media/44.b177a2fe.jpg";